import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { UnitsService } from 'src/app/core/services/units.service';
import { UserService } from 'src/app/core/services/user.service';
import { IUser } from 'src/app/core/interfaces/user.interface';
import { ICaseType } from 'src/app/modules/unit/interfaces/case-type.interface';
import { SuccessComponent } from 'src/app/components/shared/components/success/success.component';
import { IUnit } from 'src/app/modules/unit/interfaces/unit.interface';
import { ActivatedRoute } from '@angular/router';
import { CasesService } from 'src/app/core/services/cases.service';
import { ICaseFile } from '../../../interfaces/case-file.interface';
import { AlertService } from 'src/app/modules/case-new-view/alert.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';

enum texts {
  title = 'Crear alerta',
  editTitle = 'Editar alerta',
  create = 'Crear',
  edit = 'Editar',
}

@Component({
  selector: 'app-create-alert',
  templateUrl: './create-alert.component.html',
  styleUrls: ['./create-alert.component.scss'],
})
export class CreateAlertComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  displayedColumns: string[] = [
    'referenceTransaction',
    'monto_salio',
    'opciones',
  ];

  dataSource = new MatTableDataSource<any>();
  public Texts = texts;
  additionalFormValid: boolean = true;
  aditionalInfoForm: any = null;
  caseId: string = null;
  createCase: boolean = false;
  unit: IUnit;
  constructor(
    private readonly casesService: CasesService,
    public readonly userService: UserService,
    private readonly fb: FormBuilder,
    private readonly dialog: MatDialog,
    private readonly unitsService: UnitsService,
    private readonly dialogRef: MatDialogRef<CreateAlertComponent>,

    private readonly alertService: AlertService,

    private route: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      alert?: any; //cambiar
      unit: String;
    }
  ) {
    // this.getUnit(this.data.unit);
  }
  today: Date = new Date();
  typeOfPerson = ['V', 'E', 'P', 'J', 'R', 'I', 'G'];
  priority = ['Bajo', 'Medio', 'Alto'];
  form = this.fb.group({
    caseType: ['', [Validators.required]],
    description: ['', [Validators.required]],
  });
  fraudeForm = this.fb.group({
    tipo_de_persona: ['', [Validators.required]],
    numero_de_identificacion: [
      { value: '', disabled: true },
      [Validators.required, Validators.pattern('^\\d{6,9}$')],
    ],
    apellido: [
      '',
      [
        Validators.required,
        Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]{1,30}$'),
      ],
    ],
    nombre: [
      '',
      [
        Validators.required,
        Validators.pattern('^[a-zA-ZÀ-ÿ\u00f1\u00d1 ]{1,30}$'),
      ],
    ],
    oficina: ['', [Validators.required]],
    region: ['', [Validators.required]],
    telefono: [
      '',
      [Validators.required, Validators.pattern('^\\(\\d{4}\\) \\d{7}$')],
    ],
    correo: [
      '',
      [
        Validators.required,
        Validators.email,
        Validators.pattern('^[A-Za-z0-9._%-]+@[A-Za-z0-9.-]+\\.[A-Za-z]{2,}$'),
      ],
    ],
    celular: [
      '',
      [Validators.required, Validators.pattern('^\\(\\d{4}\\) \\d{7}$')],
    ],
    cliente: ['', [Validators.required]],
    domicilio: ['', [Validators.required]],
    tipo_registro: [''],
    canal: ['', [Validators.required]],
    instrumento: ['', [Validators.required]],
    priority: ['', [Validators.required]],
    descripcion: ['', [Validators.required]],
    // monto_salio: [''],
    dateEvent: ['', [Validators.required]],
    numberIdInstrumnet: [{ value: '', disabled: true }, [Validators.required]],
    // referenceTransaction: [''],
    dataTransactions: [''],
  });

  formTable = this.fb.group({
    referenceTransaction: [''],
    monto_salio: ['', [Validators.required]],
  });
  // get caseType() {
  //   if (this.isEditing) {
  //     return this.data.case.caseType._id;
  //   } else {
  //     return this.form.get('caseType').value;
  //   }
  // }

  get isEditing() {
    return !!this.data?.alert;
  }

  caseTypes: ICaseType[] = [];
  oficinasExample: any[] = ['oficina 1', 'oficina 2', 'oficina 3'];
  regionesExample: any[] = ['región 1', 'región 2', 'región 3'];
  canalesExample: any[] = [
    'ATM',
    'POS',
    'SMS MOVIL',
    'BT MOVIL',
    'BT ENLINEA',
    'TAQUILLA',
  ];
  instrumentosExample: any[] = ['Tarjeta', 'Cuenta'];
  ngAfterViewInit() {
    this.dataSource = new MatTableDataSource(this.tableValues);
    this.dataSource.paginator = this.paginator;
  }
  ngOnInit() {
    // this.getCaseTypes();
    if (this.isEditing) {
      const caseEdit = this.data.alert;

      let data = {
        caseType: caseEdit.caseType._id,
        assigned: caseEdit.assigned?._id || null,
        description: caseEdit.description,
      };
      this.form.patchValue(data);
      this.fraudeForm.patchValue(caseEdit.additionalInformation);

      this.form.get('caseType').disable();
      this.casesService.getFiles(caseEdit._id).subscribe({
        next: (files) => {
          this.files = files;
        },
      });
    }

    this.fraudeForm.get('tipo_de_persona').valueChanges.subscribe((value) => {
      const numeroControl = this.fraudeForm.get('numero_de_identificacion');
      if (!value || value === '') {
        numeroControl.disable();
      } else {
        numeroControl.enable();
      }
      if (value == 'V' || value == 'E' || value == 'P') {
        numeroControl.setValidators([
          Validators.required,
          Validators.pattern('^\\d{6,9}$'),
        ]);
      } else {
        numeroControl.setValidators([
          Validators.required,
          Validators.pattern('^\\d{8}-\\d$'),
        ]);
      }
      // Update the validity state
      numeroControl.updateValueAndValidity;
    });

    this.fraudeForm.get('instrumento').valueChanges.subscribe((value) => {
      const numeroControl = this.fraudeForm.get('numberIdInstrumnet');
      console.log(value);
      if (!value || value === '') {
        numeroControl.disable();
      } else {
        numeroControl.enable();
      }
      console.log('x');

      if (value == 'Tarjeta') {
        numeroControl.setValidators([
          Validators.required,
          Validators.pattern('^\\d{16}$'),
        ]);
      } else if (value == 'Cuenta') {
        numeroControl.setValidators([
          Validators.required,
          Validators.pattern('^\\d{20}$'),
        ]);
      }
      // Update the validity state
      numeroControl.updateValueAndValidity;
    });
  }

  // async findUser() {
  //   let caseType = this.caseTypes.find((item) => item._id == this.caseType);
  //   const roles = caseType.role;
  //   const users: IUser[] = [];

  //   for (const role of roles) {
  //     const usersByRole = await this.userService
  //       .getUsersByRole(role)
  //       .toPromise();
  //     users.push(...usersByRole);
  //   }

  //   this.users = users;
  // }

  users: IUser[] = [];

  // getCaseTypes() {
  //   this.unitsService.getTypeCases(this.data.unit).subscribe({
  //     next: (caseTypes) => {
  //       this.caseTypes = caseTypes;
  //       this.form.value.caseType = this.caseTypes[0]._id;
  //       if (this.caseType) {
  //         this.findUser();
  //       }
  //     },
  //   });
  // }

  files: ICaseFile[] = [];
  newFiles: ICaseFile[] = [];
  deleteFiles: ICaseFile[] = [];

  closeModal() {
    this.dialogRef.close();
  }

  save() {
    if (this.isEditing) {
      this.edit();
    } else {
      this.create();
    }
  }

  edit() {
    this.isLoading = true;

    const data = this.fraudeForm.value; //this.form.value;

    // data.caseType = this.data.case.caseType._id;
    data.newFiles = this.newFiles;
    data.deleteFiles = this.deleteFiles;
    data.additionalInformation = this.fraudeForm.value;
    // if (data.status != this.data.case.status) {
    //   switch (data.status) {
    //     case 'initial':
    //       data.initialAt = new Date();
    //       break;
    //     case 'running':
    //       data.runningAt = new Date();
    //       break;
    //     case 'tobeApproved':
    //       data.tobeApprovedAt = new Date();

    //       break;
    //     case 'toFinalize':
    //       data.toFinalizeAt = new Date();
    //       break;
    //     default:
    //       break;
    //   }
    // }

    // data.user_changing = this.userService.currentUser._id;

    this.alertService.updateAlert(this.data.alert._id, data).subscribe({
      next: (caseUpdated: any) => {
        // this.casesService
        //   .saveAuditory('EditCase', caseUpdated)
        //   .subscribe((res) => console.log(' '));
        this.isLoading = false;
        this.alert('Caso editado con éxito');
        this.caseId = caseUpdated._id;
        this.createCase = true;

        caseUpdated.additionalInformation = this.aditionalInfoForm;
        if (typeof caseUpdated.caseType.unit == 'object') {
          caseUpdated.caseType.unit = caseUpdated.caseType.unit._id;
        }

        this.dialogRef.close(caseUpdated);
      },
      error: (err) => {
        console.log(err);

        this.alert(err.error);
        this.isLoading = false;
      },
    });
  }

  isLoading = false;

  alert(title: string) {
    this.dialog.open(SuccessComponent, {
      data: { title },
    });
  }

  additionalFormValidChange(info: any) {
    this.additionalFormValid = info.val;
    this.aditionalInfoForm = info.additionalInformation;
  }

  create() {
    this.isLoading = true;
    this.fraudeForm.value.tipo_registro = 'Manual';
    this.fraudeForm.value.dataTransactions = this.tableValues;
    const data = this.fraudeForm.value; //this.form.value;
    // data.files = this.files;
    // data.caseType = this.caseTypes[0]._id;
    data.unit = this.data.unit;
    data.correo.toLowerCase();
    data.creator = this.userService.currentUser._id;

    this.alertService.createAlert(data).subscribe({
      next: (alertCreated: any) => {
        this.isLoading = false;
        this.alert('Alerta creada con éxito!');
        this.caseId = alertCreated._id;
        this.createCase = true;
        alertCreated.additionalInformation = this.aditionalInfoForm;
        // if (typeof alertCreated.caseType.unit == 'object') {
        //   alertCreated.caseType.unit = alertCreated.caseType.unit._id;
        // }

        if (
          this.userService.currentUser.role.createCases &&
          this.userService.currentUser.role.editCases
          //||
          //alertCreated.assigned._id == this.userService.currentUser._id
        ) {
          this.alertService.alertCreated.next(alertCreated); //cambiar
        }
        this.dialogRef.close();
      },
      error: (err) => {
        console.log(err);

        this.alert(err.error);
        this.isLoading = false;
      },
    });
  }

  //Obtener la unidad en la que se encuentra
  async getUnit(id) {
    await this.unitsService.getById(id).subscribe((res) => {
      this.unit = res;
    });
  }
  holdingInput;
  instrumentId = 'T';
  changeInstrument() {
    console.log(this.fraudeForm.value.instrumento);

    if (this.fraudeForm.value.instrumento == 'Tarjeta') {
      this.instrumentId = 'T';
    } else if (this.fraudeForm.value.instrumento == 'Cuenta') {
      this.instrumentId = 'C';
    }
  }
  personId = 'V';
  changeCi() {
    if (
      this.fraudeForm.value.tipo_de_persona[0].toUpperCase() == 'V' ||
      this.fraudeForm.value.tipo_de_persona[0].toUpperCase() == 'E' ||
      this.fraudeForm.value.tipo_de_persona[0].toUpperCase() == 'P'
    ) {
      this.personId = 'V';
    } else {
      this.personId = 'J';
    }
    // if (this.form.value.numero_de_identificacion) {
    // let ci = this.fraudeForm.value.numero_de_identificacion;
    // if (ci != '') {
    //   ci = ci.split('');
    //   if (
    //     !this.includesLetter(this.fraudeForm.value.numero_de_identificacion)
    //   ) {
    //     ci.splice(0, 0, this.fraudeForm.value.tipo_de_persona[0].toUpperCase());
    //   } else {
    //     ci.splice(0, 1, this.fraudeForm.value.tipo_de_persona[0].toUpperCase());
    //   }
    //   ci = ci.join('');
    // } else {
    //   ci = this.fraudeForm.value.tipo_de_persona[0].toUpperCase();
    // }
    // // ci[0] = this.fraudeForm.value.tipo_de_persona[0].toLowerCase();
    // this.fraudeForm.controls.numero_de_identificacion.setValue(ci);
    // }
  }
  includesLetter(ci: any) {
    for (let type of this.typeOfPerson) {
      if (ci.includes(type)) {
        return ci.includes(type);
      }
    }
  }
  valueOfCelular;
  permanentCelular = [];
  // logData(key) {
  //   if (key.key == 'Backspace') {
  //     this.permanentCelular.splice(-1, 1);
  //   } else if (!isNaN(parseFloat(key.key))) {
  //     this.permanentCelular.push(key.key);
  //   }
  //   let valorMomentaneo = [...this.permanentCelular];
  //   let indexOpen = valorMomentaneo.findIndex((v) => v == '(');
  //   let indexClose = valorMomentaneo.findIndex((v) => v == ')');
  //   if (this.permanentCelular.length >= 4) {
  //     if (indexOpen == -1 && indexClose == -1) {
  //       valorMomentaneo.splice(0, 0, '(');
  //       valorMomentaneo.splice(5, 0, ')'); //splice(-1, 0, ')');
  //     }
  //   } else if (this.permanentCelular.length < 5) {
  //     if (indexOpen != -1 && indexClose != -1) {
  //       valorMomentaneo.splice(indexOpen, 1);
  //       valorMomentaneo.splice(indexClose, 1);
  //     }
  //   }
  //   this.fraudeForm.controls.celular.setValue(valorMomentaneo.join(''));
  //   console.log(valorMomentaneo);
  // }
  logData(key) {
    if (key.key == 'Backspace') {
      this.permanentCelular.splice(-1, 1);
    } else if (!isNaN(parseFloat(key.key))) {
      this.permanentCelular.push(key.key);
    }

    let valorMomentaneo = [...this.permanentCelular];
    let indexOpen = valorMomentaneo.findIndex((v) => v == '(');
    let indexClose = valorMomentaneo.findIndex((v) => v == ')');

    if (this.permanentCelular.length >= 4) {
      if (indexOpen == -1 && indexClose == -1) {
        valorMomentaneo.splice(0, 0, '(');
        valorMomentaneo.splice(5, 0, ')');
      }
    } else if (this.permanentCelular.length < 5) {
      if (indexOpen != -1 && indexClose != -1) {
        valorMomentaneo.splice(indexOpen, 1);
        valorMomentaneo.splice(indexClose, 1);
      }
    }
    // Elimina cualquier carácter no numérico
    const numericValue = valorMomentaneo.join('').replace(/\D/g, '');

    // Formatea el número como (xxxx)xxxxxxxx
    const formattedValue = `(${numericValue.slice(0, 4)})${numericValue.slice(
      4
    )}`;
    this.fraudeForm.controls.celular.setValue(formattedValue);
  }
  tableValues = [];
  submit = false;

  initializeTable() {
    this.dataSource = new MatTableDataSource(this.tableValues);
    this.dataSource.paginator = this.paginator;

    this.submit = false;
  }
  addData() {
    if (this.formTable.invalid || this.submit) return;
    this.submit = true;
    this.tableValues.unshift(this.formTable.value);
    this.formTable.reset();
    this.initializeTable();
  }
  removerCuenta(index: number) {
    this.tableValues.splice(index, 1);
    this.formTable.reset();
    this.initializeTable();
  }
}
